import Email from "@/domain/entities/emails/Email";
import MailActionType from "@/domain/enums/MailActionType";
import { isSameCopy } from "@/lib/mailIdentity";
import { Store } from "@tanstack/react-store";
import { Editor } from "@tiptap/react";

const mailStore = new Store({
    openedMail: undefined as Email | undefined,
    openMailIntent: false,
    mailActionType: MailActionType.REPLY as MailActionType,
    editor: undefined as Editor | undefined,
    // True while the inline reply (inside the slide-out panel) is full screen.
    // SlideOutModal uses it to raise the panel above the fixed header.
    isMailInputFullScreen: false,
});

export type SetOpenedMailOptions = {
    /** Action type for compose (reply, reply all, forward). Defaults to REPLY when mail changes. */
    actionType?: MailActionType;
    /** When true, EmailView will switch to SIDE_LIST and update read status. Defaults to true when mail is defined. */
    openIntent?: boolean;
};

export const setOpenedMail = (
    mail: Email | undefined,
    options?: SetOpenedMailOptions,
) => {
    mailStore.setState((state) => {
        const isSameMail =
            !!state.openedMail && !!mail && isSameCopy(state.openedMail, mail);
        const openIntent = options?.openIntent ?? !!mail;
        const actionType =
            options?.actionType ??
            (isSameMail ? state.mailActionType : MailActionType.REPLY);

        return {
            ...state,
            openedMail: mail,
            openMailIntent: openIntent,
            mailActionType: actionType,
        };
    });
};

export const clearOpenMailIntent = () => {
    mailStore.setState((state) => ({
        ...state,
        openMailIntent: false,
    }));
};

export const setMailInputFullScreen = (isMailInputFullScreen: boolean) => {
    mailStore.setState((state) => ({
        ...state,
        isMailInputFullScreen,
    }));
};

export const setMailActionType = (actionType: MailActionType) => {
    mailStore.setState((state) => ({
        ...state,
        mailActionType: actionType,
    }));
};

export default mailStore;
